import { checkIsInternal } from '@src/utility/createStorage';
import HttpService from '@src/utility/httpService';
import { config } from '@uhg-abyss/web/tools/config';
import { LOB, REGION, TIME_PERIOD } from '@src/apps/ProviderExperience/constant';
import { peiEndPoints } from '@src/constants/endpoints-constants';

const _httpService = new HttpService();
if (checkIsInternal()) {
    _httpService.setBaseURL(config('API_DOMAIN_INTERNAL'));
}
else {
    _httpService.setBaseURL(config('API_DOMAIN_EXTERNAL'));
}

export const getProviderExperienceQuickFilterData = async (payload: any) => {
    try {
        const quickFilterData = [
            { ...TIME_PERIOD },
            { ...REGION },
            { ...LOB },]
        return { Data: quickFilterData };
    } catch {
        return null;
    }
}

export const getClaimsData = async (payload: any) => {
    try {
        const periodQuery = payload.period ? `&requestPeriod=${payload.period}` : '';
        const responseData: any = await _httpService.push(peiEndPoints.claimsData + `?cardType=${payload.cardType}${periodQuery}`, payload);
        return responseData;
    } catch(error) {
        return {  status: false,  error };
    }
}
export const getEffortIndexData = async (payload: any) => {
    try {
        const responseData: any = await _httpService.push(peiEndPoints.effortIndexData, payload);
        return responseData;
    } catch(error) {
        return {  status: false,  error };
    }
}

export const getServiceMetricData = async (payload: any) => {
    try {
        const responseData: any = await _httpService.push(peiEndPoints.serviceMetric, payload);
        return responseData;
    } catch(error) {
        return {  status: false,  error };;
    }
}